import { Message } from 'element-ui'
// import  config   from '@/axios/config'
import  store   from '@/store'
import  router   from '@/router'
import { post } from '@/axios/api.js';
// 文件下载或上传域名

export const up = {
	// 批量新增账户表格下载地址
	downloadExcel : (file) => {
		if(file==0){
			return config.baseUrl + 'statics/user1.xlsx'
		}else{
			return config.baseUrl + 'statics/user2.xlsx'
		}
	},
	// 共同体表格
	downloadExcels: (file) => {
		return config.baseUrl + 'statics/member.xlsx'
	},
	// downloadExcel:config.baseUrl + '/statics/user.xlsx',
	// 资源下载
	download:config.baseUrl + '?c=d_admin&m=down_file',
	//  文件上传域名
	 uploadFile:config.uploadFile,
	uploadExcel:config.uploadExcel,
	
	// 图片上传域名
	uploadImg:config.uploadImg,
	
	
	// 图片上传域名
	// http:config.requestRemoteIp().then(res => {
	// 	// return uploadHttp[0];
	// 	return res.http;
	// }),
	// 图片上传限制
	beforeAvatarUpload : (file) => {
		console.log(123);
		store.state.resourcelist.type = "image"
		store.state.newslist.type = "image"
		const isPNG = file.type === 'image/png'
		|| file.type === 'image/jpg'
		|| file.type === 'image/jpeg';
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isPNG) {
			Message.error('请上传正确的图片格式!');
			return false;
		}else if (!isLt2M) {
			Message.error('上传图片大小不能超过 2MB!');
			return false;
		}
	},
	//  视频上传限制
		beforeAvatarUploadsVideo(file) {
			const isVideo = file.type === 'video/mp4'
			const isLt2M = file.size / 1024 / 1024 < 200;
			if (!isLt2M) {
				this.$message.error('上传文件大小不能超过 200MB!');
				return isLt2M;
			}else if(!isVideo){
				Message.error('请上传正确的视频格式!');
				return false;
			}
		},
  
    // pdf word上传限制
	beforeAvatarUploadsWd(file) {
		console.log(file.type);
		const isLt50M = file.size / 1024 / 1024 < 50;
		const isPDF = file.type === 'application/pdf'||file.type=='application/msword'||file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document';
		if (!isLt50M) {
			this.$message.error('上传文件大小不能超过 50MB!');
			return false;
		}else if(!isPDF){
			Message.error('请上传正确的文件格式!');
			return false;
		}
	

		
	},



	// 文件上传限制
	beforeKjUpload : (file) => {
		// .pptx  .ppt
		store.state.resourcelist.type = "file"
		if(store.state.resourcelist.uploaddata.moduleClass[0] != 3){
			if(store.state.resourcelist.uploaddata.bsid == 1){
				// 视频
				const isPPT = file.type === 'video/mp4'
				const isLt500M = file.size / 1024 / 1024 < 500;
				console.log(file)
				if (!isPPT) {
					Message.error('请上传正确的视频格式');
					return false;
				}else if (!isLt500M) {
					Message.error('上传视频大小不能超过 500MB!');
					return false;
				}
			}else if(store.state.resourcelist.uploaddata.bsid == 2){
				store.state.resourcelist.uploaddata.v_url = [];
				const isPPT = file.type === 'application/vnd.ms-powerpoint'||
							  file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
				const isLt50M = file.size / 1024 / 1024 < 50;
				if (!isPPT) {
					Message.error('请上传正确的文件格式');
					return false;
				}else if (!isLt50M) {
					Message.error('上传课件大小不能超过 50MB!');
					return false;
				}
			}else{
				store.state.resourcelist.uploaddata.v_url = [];
				const isPDF = file.type === 'application/pdf';
				const isLt50M1 = file.size / 1024 / 1024 < 50;
				if (!isPDF) {
					Message.error('请上传正确的教案格式');
					return false;
				}else if (!isLt50M1) {
					Message.error('上传教案大小不能超过 50MB!');
					return false;
				}
			}
		}else{
			// 示范课
			const isPDF = file.type === 'application/pdf'
				|| file.type === 'application/vnd.ms-powerpoint'
				|| file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
				|| file.type === 'video/mp4';
			if (!isPDF) {
				Message.error('请上传正确的示范课格式');
				return false
			}
		}
	},
	// 上传成功回调
	uploadSuccess : (res, file, fileList) => {
		if(res.status == 200 || res.code == 0){
			if(store.state.resourcelist.type == "image"){
				store.state.resourcelist.uploaddata.sz_img = res.data.src
				store.state.resourcelist.imageUrl = URL.createObjectURL(file.raw)
			}else{
				var videoItem = {
					name:store.state.resourcelist.uploaddata.title != ""?store.state.resourcelist.uploaddata.title + (store.state.resourcelist.uploaddata.v_url.length+1):store.state.resourcelist.uploaddata.v_url.length+1,
					src:res.data.src,
					bsid:res.data.bsid,
					percent:100
				}
				store.state.resourcelist.uploaddata.v_url.push(videoItem)
			}
		}else{
			Message({
				type:"error",
				message:"上传失败，请检查网络或资源类型"
			})
		}
	},
	// 新闻图片上传限制
	beforeAvatarUpload1 : (file) => {
		const isPNG = file.type === 'image/png'
		|| file.type === 'image/jpg'
		|| file.type === 'image/jpeg';
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isPNG) {
			Message.error('请上传正确的图片格式!');
			return false;
		}else if (!isLt2M) {
			Message.error('上传图片大小不能超过 2MB!');
			return false;
		}
	},
	// 上传新闻封面成功回调
	uploadSuccess1 : (res, file, fileList) => {
		if(res.status == 200 || res.code == 0){
			store.state.newslist.uploaddata.sz_img = res.data.src
			store.state.newslist.imageUrl = URL.createObjectURL(file.raw)
		}else{
			Message({
				type:"error",
				message:"上传失败，请检查网络或资源类型"
			})
		}
	},
	// 上传出错
	uploadError :(err, file, fileList) => {
		console.log(err)
	},
	// 删除上传的文件
	delFile : (index) => {
		store.state.resourcelist.uploaddata.v_url.splice(index,1);
	},
	// 预览
	preView :(bsid,index,name,src) => {
		if(bsid == 1){
			router.push({
				path:'/videoPre',
				query:{
					index:index,
					name:name,
					src:src
				}
			})
		}else if(bsid == 2){
			router.push({
				path:'/pptPre',
				query:{
					index:index,
					name:name,
					src:src
				}
			})
		}else if(bsid == 4){
			router.push({
				path:'/pdfPre',
				query:{
					index:index,
					name:name,
					src:src
				}
			})
		}
	},
	// 预览
	preViews:(bsid,index) => {
		console.log(bsid)
		if(bsid == 1){
			router.push({
				path:'/videoyl',
				query:{
					index:index
				}
			})
		}else if(bsid == 2){
			router.push({
				path:'/pptPre',
				query:{
					index:index
				}
			})
		}else if(bsid == 4){
			router.push({
				path:'/pdfqj',
				query:{
					index:index,
				}
			})
		}
	},
}

// 其他类型转换
export const others = {
	// 时间戳转换
	changeTime : time => {
		if(time != null){
			var date = new Date((parseInt(time)*1000)),
			year = date.getFullYear(),
			month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0'+ (date.getMonth() + 1),
			day = date.getDate() > 9 ? date.getDate() : '0'+ date.getDate()
			return time = year + '-' + month + '-' + day;
		}else{
			return time = "暂无数据";
		}
	},
	// 资源类型转化
	changeBsid :bsid => {
		if(bsid == 1){
			bsid = "视频"
		}else if(bsid == 2){
			bsid = "课件"
		}else if(bsid == 4){
			bsid = "教案"
		}else if(bsid == 5){
			bsid = "示范课"
		}else if(bsid == 10){
			bsid = "新闻"
		}
		return bsid;
	},
	spliceStr:(str,num) => {
		if(str.length > num){
			str = str.substring(0,num)+'...';
		}
		return str
	}
}